'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background text-foreground p-4">
      <div className="text-center max-w-md">
        <h1 className="text-4xl mb-4 text-neutral-800 dark:text-neutral-100">
          Что-то пошло не так
        </h1>
        <p className="text-lg mb-8 text-neutral-600 dark:text-neutral-300">
          Произошла ошибка при загрузке страницы.
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={reset}
            className="px-6 py-2 rounded-full bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900 hover:opacity-80 transition-opacity"
          >
            Попробовать снова
          </button>
          <Link
            href="/"
            className="px-6 py-2 rounded-full border border-neutral-300 dark:border-neutral-600 text-neutral-800 dark:text-neutral-200 hover:opacity-80 transition-opacity"
          >
            На главную
          </Link>
        </div>
      </div>
    </div>
  );
}
